import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from '@material-ui/core/styles'
import {AppBar, Toolbar, Button, Grid, SvgIcon, Menu, MenuItem} from '@material-ui/core'
import {Link} from 'react-router'
import Hidden from '@material-ui/core/es/Hidden/Hidden'
import MenuIcon from '@material-ui/icons/Menu'
import {bindActionCreators, compose} from 'redux'
import {connect} from 'react-redux'
import logo from '../../assets/logow_slogan.png'
import * as MenuActions from './redux/actions.menu'
import ExternalLink from './ExternalLink'
import MobileMenu from './MobileMenu'
import lanzoDig from '../../assets/lanzoDig.pdf'
import NewsMarquee from './NewsMarquee'

const styles = theme => ({
  navbar: {
    padding: '10px 0 10px 0',
    backgroundColor: '#fff',
    boxShadow: 'none',
    height: 120,
  },
  navbarBlack: {
    backgroundColor: 'transparent',
    boxShadow: 'none',
    height: 126,
    padding: 0,
    marginTop: 120,
    left: 0,
    right: 0,
    margin: '0 auto 30px auto',
    maxWidth: 1400,
    zIndex: 2,
    [theme.breakpoints.down('md')]: {
      maxWidth: '100%',
      marginRight: 0,
    },
  },
  navbarToolbar: {
    backgroundColor: '#000',
  },
  navbarMobile: {
    marginTop: 205,
    backgroundColor: 'transparent',
    boxShadow: 'none',
  },
  navbarTitle: {
    flex: 1,
  },
  navbarTitleLink: {
    color: 'white',
    fontSize: '32px',
  },
  navbarProfileButtonSize: {
    width: '64px',
    height: '64px',
    padding: 0,
  },
  navbarDropdown: {
    zIndex: 1,
  },
  brandImageContainer: {
    flex: 1,
  },
  button: {
    fontSize: 14,
    fontWeight: 600,
  },
  brandImage: {
    height: 100,
    width: 'auto',
    marginRight: 10,
    [theme.breakpoints.down('md')]: {
      height: 70,
    },
  },
  lanzobutton: {
    width: 150,
    marginLeft: 10,
  },
  navLink: {
    color: 'white',
    height: 94,
    borderRadius: 0,
    paddingLeft: 20,
    paddingRight: 20,
    fontSize: 16,
    fontWeight: 600,
    '&:hover': {
      backgroundColor: '#E63B43',
    },
    '&+ .navHighlight': {
      backgroundColor: '#E63B43',
    },
  },
  navDropdownMenuItem: {
    fontSize: 16,
    color: 'white',
    height: 18,
    paddingTop: 8,
    paddingBottom: 8,
    '&:hover': {
      backgroundColor: 'white',
      color: 'black',
    },
  },
  navDropdownMenuItemSelected: {
    backgroundColor: 'white',
    color: 'black',
    height: 18,
    paddingTop: 8,
    paddingBottom: 8,
    '&:hover': {
      backgroundColor: 'white',
      color: 'black',
    },
  },
  navLinkSearch: {
    color: 'white',
    height: 14,
    marginRight: 15,
    width: 120,
  },
  loginButtonsContainer: {
    width: 660,
    '& span': {
      fontSize: '13px',
      fontWeight: 600,
      textTransform: 'none',
    },
    '& svg': {
      marginRight: 5,
      marginTop: 6,
    },
  },
})

const aboutMenuItems = [
  {title: 'From the Founder', path: '/about-us'},
  {title: 'Core Values', path: '/core-values'},
  {title: 'Our History', path: '/our-history'},
  {title: 'Safety is Serious Business', path: '/safety'},
  /*{title: 'Awards & Testimonials', urlTitleSlug: 'awards-testimonials'},*/
]

const resourceMenuItems = [
  {title: 'Videos', path: '/videos'},
  {title: 'Gallery', path: '/gallery'},
  /*
  {title: 'Literature', path: ''},
  {title: 'Project Profiles', path: ''},
  {title: 'Specifications', path: ''},
  {title: 'Articles', path: ''},
  {title: 'Associations', path: ''},*/
  {title: 'CIPP Calculator', path: '/CIPP-Calculator-Request'},
]

const DesktopDropdownMenu = withStyles(() => ({
  paper: {
    marginTop: 72,
    borderRadius: 0,
    backgroundColor: '#E63B43',
    boxShadow: 'none',
    minWidth: 243,
  },
}))(Menu)

export class Header extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      desktopMenuAnchorElement: null,
    }
    this.onToolbarButtonClick = this.onToolbarButtonClick.bind(this)
    this.onDesktopMenuClose = this.onDesktopMenuClose.bind(this)
  }

  onToolbarButtonClick(e) {
    this.setState({
      desktopMenuAnchorElement: e.currentTarget,
    })
  }

  onDesktopMenuClose() {
    this.setState({
      desktopMenuAnchorElement: null,
    })
  }

  render() {
    const {props} = this
    const {classes, ctPages} = props
    const {pathname} = this.props.location
    const {desktopMenuAnchorElement} = this.state

    const loginOptions = [
      {
        component: 'a',
        title: 'Employees Login',
        href: 'https://myaccess.lanzo.org',
      },
      // {
      //   component: 'a',
      //   title: 'Customers Login',
      //   href: '/login',
      // },
      // {
      //   component: 'a',
      //   title: 'Investors Login',
      //   href: 'https://lanzoreports.com',
      // },
      // {
      //   component: Link,
      //   title: 'Sub Contractors Login',
      //   to: '/subcontractor',
      // },
    ]

    const currentDesktopCTPages =
      desktopMenuAnchorElement && desktopMenuAnchorElement.id === 'construction'
        ? ctPages.construction
        : desktopMenuAnchorElement && desktopMenuAnchorElement.id === 'trenchless'
          ? ctPages.trenchless
          : desktopMenuAnchorElement && desktopMenuAnchorElement.id === 'about'
            ? aboutMenuItems
            : desktopMenuAnchorElement && desktopMenuAnchorElement.id === 'resources'
              ? resourceMenuItems
              : []

    return (
      <Grid container justify="center">
        <Grid item xs={12}>
          <AppBar color="default" className={classes.navbar} position="fixed">
            <Grid container justify="center">
              <Grid item xs={12} md={10}>
                <Toolbar>
                  <div className={classes.brandImageContainer}>
                    <Link
                      onClick={() => this.props.onHomeClick()}
                      className={classes.navbarTitleLink}
                      to="/"
                    >
                      <img src={logo} className={classes.brandImage} />
                    </Link>
                  </div>
                  <React.Fragment>
                    <Hidden mdDown={true}>
                      <Grid container justify="flex-end" className={classes.loginButtonsContainer}>
                        {loginOptions.map(item => (
                          <Grid item>
                            <Button
                              component={item.component}
                              to={item.to || false}
                              href={item.href || false}
                              target={item.href ? '_blank' : false}
                            >
                              <SvgIcon>
                                <path
                                  d="M14.314419,7.75587903 C14.3964501,7.86525398 14.4374656,7.98830056 14.4374656,8.12501878 C14.4374656,8.26173699 14.3964501,8.38478357 14.314419,8.49415852 L7.54685701,15.1796895 C7.43748206,15.2890644 7.32127161,15.3437516 7.19822503,15.3437516 C7.07517844,15.3437516 6.95896799,15.302736 6.84959304,15.220705 L6.56248435,14.8925808 C6.45310941,14.8105497 6.39842224,14.7011748 6.39842224,14.5644565 C6.39842224,14.4277383 6.45310941,14.3046918 6.56248435,14.1953168 L11.9765339,8.82228274 L0.492186327,8.82228274 C0.355468111,8.82228274 0.239257033,8.77443108 0.143554345,8.67872839 C0.047851657,8.5830257 0,8.46681463 0,8.33009641 L0,7.91994114 C0,7.78322292 0.047851657,7.66701185 0.143554345,7.57130916 C0.239257033,7.47560647 0.355468111,7.42775481 0.492186327,7.42775481 L11.9765339,7.42775481 L6.56248435,2.05472075 C6.45310941,1.9453458 6.39842224,1.82229922 6.39842224,1.685581 C6.39842224,1.54886279 6.45310941,1.43948784 6.56248435,1.35745679 L6.84959304,1.02933257 C6.95896799,0.947301514 7.07517844,0.906285986 7.19822503,0.906285986 C7.32127161,0.906285986 7.43748206,0.947301514 7.54685701,1.02933257 L14.314419,7.75587903 Z M20.9999499,14.0312547 C20.9999499,14.5781282 20.8085439,15.0429712 20.4257326,15.4257826 C20.0429212,15.808594 19.5780781,16 19.0312046,16 L13.617155,16 C13.4804368,16 13.3642257,15.9521483 13.2685231,15.8564457 C13.1728204,15.760743 13.1249687,15.6445319 13.1249687,15.5078137 L13.1249687,15.1796895 C13.1249687,15.0429712 13.1728204,14.9267602 13.2685231,14.8310575 C13.3642257,14.7353548 13.4804368,14.6875031 13.617155,14.6875031 L19.0312046,14.6875031 C19.2226106,14.6875031 19.3798366,14.6259798 19.5028832,14.5029333 C19.6259298,14.3798867 19.6874531,14.2226607 19.6874531,14.0312547 L19.6874531,2.21878286 C19.6874531,2.02737685 19.6259298,1.87015088 19.5028832,1.74710429 C19.3798366,1.62405771 19.2226106,1.56253442 19.0312046,1.56253442 L13.617155,1.56253442 C13.4804368,1.56253442 13.3642257,1.51468276 13.2685231,1.41898008 C13.1728204,1.32327739 13.1249687,1.20706631 13.1249687,1.0703481 L13.1249687,0.742223877 C13.1249687,0.605505662 13.1728204,0.489294584 13.2685231,0.393591896 C13.3642257,0.297889208 13.4804368,0.250037551 13.617155,0.250037551 L19.0312046,0.250037551 C19.5780781,0.250037551 20.0429212,0.441443553 20.4257326,0.824254932 C20.8085439,1.20706631 20.9999499,1.67190937 20.9999499,2.21878286 L20.9999499,14.0312547 Z"
                                  fill="#000000"
                                />
                              </SvgIcon>
                              {item.title}
                            </Button>
                          </Grid>
                        ))}
                      </Grid>
                    </Hidden>
                    {/* <Button component={Link} to="/soon" variant="contained" color="primary">
                      LANZO ACADEMY
                    </Button> */}
                  </React.Fragment>
                </Toolbar>
              </Grid>
            </Grid>
          </AppBar>
          <AppBar color="default" className={classes.navbarBlack} position="fixed">
            <Toolbar style={{padding: 0}} className={classes.navbarToolbar}>
              <div className={classes.brandImageContainer}>
                <Hidden mdDown={true}>
                  <Button
                    component={Link}
                    to="/"
                    className={[classes.navLink, pathname === '/' ? 'navHighlight' : ''].join(' ')}
                  >
                    Home
                  </Button>
                  <Button
                    id="about"
                    onClick={this.onToolbarButtonClick}
                    className={[
                      classes.navLink,
                      pathname.indexOf('/about') === 0 ||
                      (desktopMenuAnchorElement && desktopMenuAnchorElement.id == 'about')
                        ? 'navHighlight'
                        : '',
                    ].join(' ')}
                  >
                    About Us
                  </Button>
                  <Button
                    id="construction"
                    onClick={this.onToolbarButtonClick}
                    className={[
                      classes.navLink,
                      pathname.indexOf('/construction') === 0 ||
                      (desktopMenuAnchorElement && desktopMenuAnchorElement.id == 'construction')
                        ? 'navHighlight'
                        : '',
                    ].join(' ')}
                  >
                    CONSTRUCTION
                  </Button>
                  <Button
                    id="trenchless"
                    onClick={this.onToolbarButtonClick}
                    className={[
                      classes.navLink,
                      pathname.indexOf('/trenchless') === 0 ||
                      (desktopMenuAnchorElement && desktopMenuAnchorElement.id == 'trenchless')
                        ? 'navHighlight'
                        : '',
                    ].join(' ')}
                  >
                    TRENCHLESS TECHNOLOGIES
                  </Button>
                  <Button
                    id="resources"
                    onClick={this.onToolbarButtonClick}
                    className={[
                      classes.navLink,
                      pathname.indexOf('/resources') === 0 ||
                      (desktopMenuAnchorElement && desktopMenuAnchorElement.id == 'resources')
                        ? 'navHighlight'
                        : '',
                    ].join(' ')}
                  >
                    RESOURCES
                  </Button>
                  <Button
                    component={ExternalLink}
                    to="https://www.lanzo.net/projects.html"
                    className={[
                      classes.navLink,
                      pathname.indexOf('/projects') === 0 ? 'navHighlight' : '',
                    ].join(' ')}
                  >
                    CURRENT PROJECTS
                  </Button>
                  <Button
                    component={Link}
                    to="/careers"
                    className={[
                      classes.navLink,
                      pathname.indexOf('/careers') === 0 ? 'navHighlight' : '',
                    ].join(' ')}
                  >
                    CAREERS
                  </Button>
                  <Button
                    component={Link}
                    to="/contactus"
                    className={[
                      classes.navLink,
                      pathname === '/contactus' ? 'navHighlight' : '',
                    ].join(' ')}
                  >
                    CONTACT US
                  </Button>
                  <DesktopDropdownMenu
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'left',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'left',
                    }}
                    anchorEl={desktopMenuAnchorElement}
                    open={Boolean(desktopMenuAnchorElement)}
                    onClose={this.onDesktopMenuClose}
                  >
                    {currentDesktopCTPages.map(item => (
                      <MenuItem
                        component={Link}
                        to={
                          item.path || '/' + desktopMenuAnchorElement.id + '/' + item.urlTitleSlug
                        }
                        className={
                          pathname === '/construction/' + item.urlTitleSlug ||
                          pathname === '/trenchless' + item.urlTitleSlug ||
                          pathname === item.path
                            ? classes.navDropdownMenuItemSelected
                            : classes.navDropdownMenuItem
                        }
                        onClick={() => {
                          window.scrollTo(0, 0)
                          this.setState({desktopMenuAnchorElement: null})
                        }}
                      >
                        {item.title}
                      </MenuItem>
                    ))}
                  </DesktopDropdownMenu>
                </Hidden>
                <Hidden lgUp={true}>
                  <Button className={classes.navLink} onClick={this.props.toggleMobileMenu}>
                    <MenuIcon />
                  </Button>
                </Hidden>
              </div>

              <React.Fragment>
                <Button
                  component="a"
                  target="blank"
                  href={lanzoDig}
                  variant="contained"
                  color="primary"
                  className={classes.navLinkSearch}
                >
                  <span style={{color: 'white'}}>LANZO DIG</span>
                </Button>
              </React.Fragment>
            </Toolbar>
            <NewsMarquee />
          </AppBar>
          <AppBar color="default" className={classes.navbarMobile} position="fixed">
            <MobileMenu
              open={this.props.menu.open ? this.props.menu.open : false}
              context={this.context}
              toggleMobileMenu={this.props.toggleMobileMenu}
              menus={[
                {
                  label: 'ABOUT US',
                  subMenu: aboutMenuItems || [],
                  basePath: '/about/',
                },
                {
                  label: 'CONSTRUCTION',
                  subMenu: ctPages.construction || [],
                  basePath: '/construction/',
                },
                {
                  label: 'TRENCHLESS TECHNOLOGIES',
                  subMenu: ctPages.trenchless || [],
                  basePath: '/trenchless/',
                },
                {
                  label: 'RESOURCES',
                  subMenu: resourceMenuItems,
                  basePath: '/resources/',
                },
                {label: 'CURRENT PROJECTS', url: 'https://www.lanzo.net/projects.html'},
                {label: 'CAREERS', url: '/careers'},
                {label: 'CONTACT US', url: '/contactus'},
              ]}
            />
          </AppBar>
        </Grid>
      </Grid>
    )
  }
}

Header.propTypes = {
  classes: PropTypes.object.isRequired,
}

Header.contextTypes = {
  router: PropTypes.object.isRequired,
}

function mapStateToProps(state) {
  return {
    menu: state.menu,
    ctPages: state.ctPages,
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(MenuActions, dispatch)
}

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withStyles(styles),
)(Header)
